<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record title="Cuenta" resource="cuentas" primaryKey="idcuenta" :record="record" :columns="columns"
        @saveChanges="handleSave" :service="service" />
    </div>
  </div>
</template>
<script>
import CardRecord from "@/components/Cards/CardRecord.vue";
import CuentaService from "@/services/cuenta.service";
import { cuenta } from "@/models/cuenta";

export default {
  components: {
    CardRecord,
  },

  data() {
    return {
      record: {},
      columns: cuenta,
      service: CuentaService
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        CuentaService.get(this.$route.params.id).then((data) => {
          this.record = data.record;
        }).catch((response) => {
          console.log(response);
        });
      },
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    }
  }
};
</script>
